import { render, staticRenderFns } from "./NutPopover.vue?vue&type=template&id=141a2ec5&scoped=true"
import script from "./NutPopover.vue?vue&type=script&lang=js"
export * from "./NutPopover.vue?vue&type=script&lang=js"
import style0 from "./NutPopover.vue?vue&type=style&index=0&id=141a2ec5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141a2ec5",
  null
  
)

export default component.exports